<template>
  <CustomDeleteDialog
    dialogTitle="حذف پلن VIP"
    dialogId="vip-delete-confirmation-dialog"
    okTitle="بله"
    no-close-on-backdrop
    :isOkDisabled="!tempUserObject || isOkButtonDisabled"
    @ok="deleteVipPlan"
  >
    <BCol cols="12">
      <p v-if="tempUserObject">
        آیا از حذف پلن
        <b-link
          :to="`/apps/vip/plans/${tempUserObject.vipUserId}`"
          style="font-weight: bold"
        >
          {{ tempUserObject.vipUser.title }}
        </b-link>
        (با قیمت
        {{ Intl.NumberFormat("en-US").format(tempUserObject.vipUser.price) }}
        تومان) از کاربر
        <b-link
          :to="`/users/${tempUserObject.userId}`"
          style="font-weight: bold"
        >
          {{ tempUserObject.fullName }}
        </b-link>
        اطمینان دارید؟
      </p>
    </BCol>
  </CustomDeleteDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    tempUserObject: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
    };
  },
  methods: {
    setStudentUserId(userId) {
      this.blockUserPayload.studentId = userId;
    },
    async deleteVipPlan() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let deleteUserVipPlan = new DeleteUserVipPlan(_this);
        deleteUserVipPlan.setRequestParam({
          userId: _this.tempUserObject.userId,
        });
        await deleteUserVipPlan.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد",
                icon: "CheckIcon",
                variant: "success",
                text: "پلن VIP با موفقیت حذف شد.",
              },
            });
            _this.$emit("refetch");
            this.$bvModal.hide("vip-delete-confirmation-dialog");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    CustomDeleteDialog,
    BCol,
    BLink,
  },
};
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BCol, BLink } from "bootstrap-vue";
import { DeleteUserVipPlan } from "@/libs/Api/VipUser";
</script>
